// extracted by mini-css-extract-plugin
export var buttonsContainer = "styles-module__buttonsContainer___XaoGQ";
export var colorDistanceSpacer = "styles-module__colorDistanceSpacer____aKOv";
export var container = "styles-module__container___uMiw3";
export var routeFormHeader = "styles-module__routeFormHeader___Q7JFV";
export var sectionTitle = "styles-module__sectionTitle___HmMB1";